import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
collection,
query,
where,
onSnapshot
} from "firebase/firestore";

import { db } from "../firebase";
import { AuthContext } from "../context/AuthContext";

import {
History,
Clock,
ArrowLeft,
TrendingUp,
Timer,
CalendarDays
} from "lucide-react";

export default function VersionHistory(){

const { projectId } = useParams();
const navigate = useNavigate();
const { orgId } = useContext(AuthContext);

const [logs,setLogs] = useState([]);
const [loading,setLoading] = useState(true);


/* ---------------- FETCH LOGS ---------------- */

useEffect(()=>{

if(!projectId || !orgId) return;

const q = query(
collection(db,"organizations",orgId,"timeLogs"),
where("projectId","==",projectId)
);

const unsubscribe = onSnapshot(q,(snap)=>{

const data = snap.docs.map(doc=>({
id:doc.id,
...doc.data()
}));

setLogs(data);
setLoading(false);

});

return ()=>unsubscribe();

},[projectId,orgId]);


/* ---------------- FORMAT TIME ---------------- */

const formatTime = (timestamp) => {

if(!timestamp) return "";

const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

return date.toLocaleTimeString([],{
hour:"2-digit",
minute:"2-digit"
});

};


/* ---------------- FORMAT DATE ---------------- */

const formatDate = (timestamp) => {

if(!timestamp) return "";

const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

return date.toLocaleDateString([],{
year:"numeric",
month:"short",
day:"numeric"
});

};


/* ---------------- UI ---------------- */

return(

<div className="max-w-5xl mx-auto px-6 py-10">

{/* BACK BUTTON */}

<button
onClick={()=>navigate(-1)}
className="flex items-center gap-2 text-indigo-600 mb-6"
>
<ArrowLeft size={18}/>
Back
</button>


{/* TITLE */}

<h2 className="text-2xl font-bold flex items-center gap-2 mb-8">
<History size={22}/>
Project Work History
</h2>


{/* LOADING */}

{loading && <p>Loading...</p>}


{/* EMPTY STATE */}

{!loading && logs.length === 0 && (

<div className="bg-white p-10 rounded-xl shadow text-center">

<History size={40} className="mx-auto text-gray-300 mb-3"/>

<p className="text-gray-500">
No work activity yet
</p>

</div>

)}


{/* LOG LIST */}

<div className="space-y-6">

{logs.map(log=>{

const minutes = Math.floor((log.duration || 0)/60);

const start = formatTime(log.createdAt);

const end = log.duration
? formatTime(
new Date(
(log.createdAt?.toDate?.() || new Date()).getTime() +
log.duration * 1000
)
)
: "";

const date = formatDate(log.createdAt);

return(

<div
key={log.id}
className="bg-white border rounded-xl p-6 shadow-sm hover:shadow-md transition"
>


{/* HEADER */}

<div className="flex justify-between items-center mb-3">

<div className="flex items-center gap-2 font-semibold text-gray-800">

<Timer size={16}/>
{log.description || "Work Session"}

</div>

<span className="text-sm bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full flex items-center gap-1">
<TrendingUp size={14}/>
{log.progress || 0}%
</span>

</div>


{/* DATE */}

<div className="flex items-center gap-2 text-sm text-gray-500 mb-2">

<CalendarDays size={14}/>
{date}

</div>


{/* TIME RANGE */}

<div className="flex items-center gap-2 text-sm text-gray-500 mb-3">

<Clock size={14}/>
{start} {end && `- ${end}`}

<span className="ml-3 text-xs bg-gray-100 px-2 py-1 rounded">
{minutes} min
</span>

</div>


{/* PROGRESS BAR */}

<div className="h-2 bg-gray-200 rounded-full overflow-hidden">

<div
className="bg-indigo-600 h-full transition-all"
style={{width:`${log.progress || 0}%`}}
/>

</div>

</div>

);

})}

</div>

</div>

);

}